import { Injectable } from '@angular/core';
import { ICmsModelResource } from '@icms/core/resource/model/icms-model.resource';
import { NBlogCategoryPageType } from '../../../cms/blog/page/category-view/cms-blog-page-category-view.component';
import { NBlogPostPageType } from '../../../cms/blog/page/post-view/cms-blog-page-post-view.component';
import { NBlogRootPageType } from '../../../cms/blog/page/root-view/cms-blog-page-root-view.component';
import { LocalICmsPage } from './local-page';

@Injectable({
    providedIn: 'root'
})
export class LocalPageResource extends ICmsModelResource<LocalICmsPage, number> {
    static override instance = LocalICmsPage;
    readonly invalidatesUniversal = true;
    readonly invalidatesPrerender = true;

    /**
     * Loads all blog categories
     */
    loadBlogRoot(verbosity = 2): Promise<LocalICmsPage[]> | void {
        return this.find({ filter: { pageType: NBlogRootPageType.typeId }, verbosity });
    }

    /**
     * Loads all blog categories
     */
    loadBlogCategories(verbosity = 2): Promise<LocalICmsPage[]> | void {
        return this.find({ filter: { pageType: NBlogCategoryPageType.typeId }, verbosity });
    }

    /**
     * Loads all blog posts
     */
    loadBlogPosts(verbosity = 2): Promise<LocalICmsPage[]> | void {
        return this.find({ filter: { pageType: NBlogPostPageType.typeId }, verbosity });
    }
}
